module.exports = __webpack_public_path__ + "img/blankscreen_100.bf671651.jpg";